// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { MailModule } from './apps/mail/mail.module';
import { ECommerceModule } from './apps/e-commerce/e-commerce.module';
import { UserManagementModule } from './user-management/user-management.module';
//import { MyPageComponent } from './my-page/my-page.component';
//import { ReportsModule } from './reports/reports.module';

import {PlantConfigurationModule} from './plant-configuration/plant-configuration.module'
import { Controlir4ConfigModule } from './controlir4-config/controlir4-config.module';


@NgModule({
	declarations: [
		//MyPageComponent,
		],
	exports: [],
	imports: [
		CommonModule,
		// HttpClientModule,
		FormsModule,
		CoreModule,
		PartialsModule,
		MailModule,
		ECommerceModule,
		UserManagementModule,
		//ReportsModule,
		PlantConfigurationModule,
		Controlir4ConfigModule
	],
	providers: []
})
export class PagesModule {
}
